import * as VueRouter from "vue-router";
import SearchEngineContent from "../components/search-engine/SearchEngineContent";
import AdminPage from "../components/admin/AdminPage";
import LoginPage from "../components/login/LoginPage";
import LogsPage from "../components/logs/LogsPage";
import ResetPasswordPage from "../components/login/ResetPasswordPage";
import UnAuthorizedPage from "../components/layout/UnAuthorizedPage";
import FirebaseService from "../components/service/FirebaseService";

const useLoginPage = process.env.VUE_APP_USE_LOGIN_PAGE === "true";

const requireAuth = async (to, from, next) => {
  if (useLoginPage) {
    const { user } = FirebaseService.getUser();
    if (!user.value) {
      // Redirect user to login page
      next({ name: 'login'});
    } else {
      next();
    }
  } else {
    next();
  }
}

const requireNoAuth = async (to, from, next) => {
  if (useLoginPage) {
    const { user } = FirebaseService.getUser();
    if (user.value) {
      // Redirect user to home page
      next({ name: 'index'});
    } else {
      next();
    }
  } else {
    // Redirect user to home page
    next({ name: 'index'});
  }
}

const routes = [
  {
    path: "/",
    component: SearchEngineContent,
    name: "index",
    meta: { title: "FacDocs System" },
    beforeEnter: requireAuth
  },
  {
    path: "/admin",
    component: AdminPage,
    name: "admin",
    meta: { title: "Admin - FacDocs System" },
    beforeEnter: requireAuth
  },
  {
    path: "/login",
    component: LoginPage,
    name: "login",
    meta: { title: "Login - FacDocs System" },
    beforeEnter: requireNoAuth
  },
  {
    path: "/logs",
    component: LogsPage,
    name: "logs",
    meta: { title: "Logs - FacDocs System" },
    beforeEnter: requireAuth
  },
  {
    path: "/resetPassword",
    component: ResetPasswordPage,
    name: "resetPassword",
    meta: { title: "Reset Password - FacDocs System" },
    beforeEnter: requireNoAuth
  },
  {
    path: "/unauth",
    component: UnAuthorizedPage,
    name: "unauth",
    meta: { title: "Unauthorized - FacDocs System" },
    beforeEnter: requireAuth
  }
]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes, // short for `routes: routes`
})

router.beforeEach((to, from, next) => {
  if (router.hasRoute(to.name)) {
    next();
  } else {
    next('/');
  }
});

router.afterEach(to => {
  if (to.meta.title) {
    // Sets the browser tab's title
    document.title = to.meta.title;
  }
});

export default router;